import React from 'react'
import { Link } from 'react-router-dom'

const TermsAndCondition = () => {
    return (
        <div className='container-fluid p-2'>

            <h3 className="text-center">Terms and Conditions</h3>

            <p><strong>Effective Date:</strong> [25/12/2024]</p>
            <p><strong>Last Updated:</strong> [06/02/2025]</p>

            <p>Welcome to the PLOT 1.0 (the &quot;Software&quot;). By accessing or using the Software, you agree to be bound by these Terms and Conditions (the &quot;Agreement&quot;). If you do not agree with these terms, please do not use the Software.</p>


            <h4>1. Ownership and Intellectual Property</h4>

            <p>1.1 The Software, including all associated designs, features, and functionalities, is the sole and exclusive property of PBOPlus Consulting Pvt. Ltd. (&quot;We,&quot; &quot;Us,&quot; &quot;Our&quot;).</p>

            <p>1.2 All copyrights, trademarks, and other intellectual property rights in and to the Software are owned by Us. Unauthorized copying, distribution, or modification is strictly prohibited.</p>

            <p>1.3 Any improvements, modifications, or customizations made to the Software based on client feedback or collaboration remain our exclusive property and do not constitute a transfer of ownership to the client.</p>


            <h4>2. Usage Rights</h4>

            <p>2.1 Users are granted a limited, non-exclusive, non-transferable right to access and use the Software for its intended purposes.</p>

            <p>2.2 Users agree not to copy, reverse-engineer, or create derivative works of the Software.</p>


            <h4>3. Data Liability and Security</h4>

            <p>3.1 While we take reasonable precautions to secure user data, we are not liable for any data loss, corruption, or breaches caused by unauthorized access or hacking.</p>

            <p>3.2 Users are responsible for maintaining their own backups of any data uploaded to the Software.</p>

            <h4>4. Limitation of Liability</h4>

            <p>4.1 We are not responsible for any indirect, incidental, or consequential damages arising from the use or inability to use the Software.</p>

            <p>4.2 Users assume all risks associated with the use of the Software, including but not limited to operational errors, technical issues, or unauthorized access.</p>


            <h4>5. Confidentiality and Data Use</h4>

            <p>5.1 We reserve the right to use anonymized and aggregated data from the Software for analytical and improvement purposes only.</p>

            <p>5.2 We do not sell or share user data with third parties without explicit consent, except as required by law.</p>


            <h4>6. Termination of Access</h4>

            <p>6.1 We reserve the right to suspend or terminate user access to the Software at any time, with or without notice, for breach of this Agreement or other misuse.</p>


            <h4>7. Jurisdiction and Dispute Resolution</h4>

            <p>7.1 This Agreement shall be governed by and construed in accordance with the laws of India.</p>

            <p>7.2 Any disputes arising from this Agreement shall be subject to the exclusive jurisdiction of the courts of New Delhi, India.</p>


            <h4>8. Acceptance of Terms</h4>

            <p>8.1 By accessing the Software, users acknowledge that they have read, understood, and agree to these Terms and Conditions.</p>


            <h4>9. Changes to Terms</h4>

            <p>9.1 We reserve the right to modify these Terms and Conditions at any time. Continued use of the Software constitutes acceptance of any changes.</p>


            <p style={{ marginBottom: '5px' }}>For any questions or concerns regarding this Agreement, please contact us at:</p>

            <p style={{ marginTop: '2px', marginBottom: '2px' }}><strong>PBOPlus Consulting Pvt. Ltd.</strong></p>
            <p> <Link to="mailto:plot@pboplus.com" className='text-decoration-underline'>plot@pboplus.com</Link></p>
        </div >

    )
}

export default TermsAndCondition
